import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/agentConversation/agentConversation.query.gql"
import type {
  AgentConversationQuery,
  AgentConversationQueryVariables,
} from "@/v2-backoffice-client/agentConversation/__types__/agentConversation.query"

type Options = QueryHookOptions<
  AgentConversationQuery,
  AgentConversationQueryVariables
>

export function useAgentConversationQuery(options?: Options) {
  return useQuery<AgentConversationQuery, AgentConversationQueryVariables>(
    query,
    options,
  )
}
